
export const Cursed = () => {
  return (
    <div id='category'>
      <div className="row">
        <div className="col-xs-12 col-md-6">
          <div className="about-text">
            <h2>THE CURSED GREYHOUNDS</h2>
            <h4>In the history of the founder there are secrets and clues that would lead members to a new collection. In order to release the curse of the greyhounds, you need to get 6 relics that are all over the Galgon Earth.</h4>
            <h4>It is a collection that is unlocked at the community level and those who find the relics will receive another greyhound for their collection.</h4>
            <h4>Only Greyhound members will be able to be part of the minting process once the 6 relics are collected and brought to the society.</h4>
          </div>
        </div>
        <div className="col-xs-12 col-md-6" style={{display: 'flex', justifyContent: 'center'}}>
          <img style={{width: 500}} src="./img/cursed.jpg" className="img-responsive" alt="" />{" "}
        </div>
      </div>
    </div>
  )
}
